import { axiosObject } from '../setup';

function getSellerQueries(params) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_ONBOARDING_API_URL}/response`;
    // console.log(params,"nooo")
    axiosObject
      .get(uri, { params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        console.log('errr', errors);
        reject(errors);
      });
  });
}

export { getSellerQueries };
